import { TransactionErrorKey } from '@api/hooks/useBatch.ts';
import { Button } from '@gurupay/gp-ui-library';
import clsx from 'clsx';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

const ERROR_KEYS = Object.values(TransactionErrorKey);

interface ErrorFilterProps {
	availableKeys: TransactionErrorKey[];
	selectedKeys: TransactionErrorKey[];
	onChange: (keys: TransactionErrorKey[]) => void;
}

export const ErrorFilter: FC<ErrorFilterProps> = ({
	availableKeys,
	selectedKeys,
	onChange,
}) => {
	const { t } = useTranslation('', { keyPrefix: 'payments.batch.table' });

	const handleToggle = (key: TransactionErrorKey) => {
		if (selectedKeys.includes(key)) {
			onChange(selectedKeys.filter((k) => k !== key));
		} else {
			onChange([...selectedKeys, key]);
		}
	};

	const visibleKeys = ERROR_KEYS.filter((key) => availableKeys.includes(key));

	return (
		<div className="flex flex-wrap gap-space-8 mb-space-8">
			{visibleKeys.map((key) => {
				const isSelected = selectedKeys.includes(key);
				return (
					<Button
						key={key}
						className={clsx(
							'hover:bg-transparent',
							isSelected ? '!border-neutral-950' : '!border-neutral-200',
						)}
						onClick={() => handleToggle(key)}
						size="sm"
						variant="outlined"
					>
						{t(key.replaceAll('.', '_'))}
					</Button>
				);
			})}
		</div>
	);
};

ErrorFilter.displayName = 'ErrorFilter';
